var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.systemNotification)?_c('div',[_c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-stage"},[_vm._v(" "+_vm._s(_vm.systemNotification.title)+"   -   "+_vm._s(_vm.systemNotification.message)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }